<template>
    <div id="app">
        <template v-if="getInternetExplorerVersion() == -1">
            <optionen v-if="config.zeigeOptionen" :config="config"></optionen>

            <template v-if="config.zeigeHinweise">
                <div class="row">
                    <diagramm :klasse="klasse"></diagramm>
                    <hinweise v-if="config.zeigeHinweise" :klasse="klasse" class="rechts"></hinweise>
                </div>
                <java-code v-if="config.zeigeJavaCode" :klasse="klasse" class="javaunten"></java-code>
            </template>

            <template v-else>
                <div class="row">
                    <diagramm :klasse="klasse"></diagramm>
                    <java-code v-if="config.zeigeJavaCode" :klasse="klasse" class="rechts javarechts"></java-code>
                </div>
            </template>

            <raw-data v-if="config.zeigeRawData" :config="config"></raw-data>
        </template>
        <template v-else>
            <p><strong>Funktioniert leider nicht mit dem Internet Explorer. Benutze bitte einen anderen Browser!</strong></p>
        </template>
    </div>
</template>

<script>
    import Diagramm from './components/Diagramm.vue';
    import Hinweise from './components/Hinweise.vue';
    import JavaCode from './components/JavaCode.vue';
    import Optionen from './components/Optionen.vue';
    import RawData from "./components/RawData.vue";

    export default {
        name: 'app',
        props: ['init'],
        data() {
            return {
                klasse: this.init.klasse, // enthält nur die Klasse
                config: this.init, // enthält die gesamte Konfiguration
            }
        },
        methods: {
            getInternetExplorerVersion() {
                // Quelle: http://blog.julitec.com/dev/prüfen-ob-internet-explorer-verwendet-wird-inklusive-ie-11
                var rV = -1; // Return value assumes failure.

                if (navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == 'Netscape') {
                    var uA = navigator.userAgent;
                    var rE = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

                    if (rE.exec(uA) != null) {
                        rV = parseFloat(RegExp.$1);
                    }
                    /*check for IE 11*/
                    else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                        rV = 11;
                    }
                }
                return rV;
            }

        },
        components: {
            Diagramm,
            Hinweise,
            JavaCode,
            Optionen,
            RawData,
        }
    }
</script>

<style>
    .row {
        display: flex;
    }

    .rechts {
        margin-left: 10px;
    }

    .javaunten {
        margin-top: 10px;
    }

    .javarechts {
        flex: 1;
    }
</style>



// WEBPACK FOOTER //
// App.vue?2b2cf2ce